



































import Vue, { PropType } from 'vue'
import IListActionMenu from '@/components/IListActionMenu.vue'
import IListAction from '@/types/components/IListAction.interface'
import inputsMixin from '@/mixins/inputs-mixin'
import Button from '@/types/components/Button.interface'
export default Vue.extend({
    components: { IListActionMenu },
    mixins: [inputsMixin],
    props: {
        action: {
            type: Object as PropType<IListAction>,
            default: null
        }
    },
    computed: {
        menu(): Button[] {
            //  Grab our action menu
            const menu = this.action.menu

            //  If we have no menu, return null
            if (!menu) return null

            //  @ts-ignore Else, filter out any hidden items
            const filtered = menu.filter((x: Button) => this.isVisible(x))

            //  If our filtered is empty, return null
            if (!filtered.length) return null

            //  Else, return the filtered
            return filtered
        }
    }
})
